<!-- Main Authentication Page -->
<div class="flex flex-row container">
  <!-- left side page -->
  <div class="w-6 h-screen pt-2 flex flex-column justify-content-around align-items-center signin-div">
    <div class="w-11 flex flex-row">
      <img class="align-items-start logo-image" src="assets/images/logo.png" />
    </div>
    <div class="h-30rem w-12 flex flex-column justify-content-center login-form mt-8">
        <form *ngIf="!changeSuccess" [formGroup]="forcedPasswordChangeForm">
            <h3 class="font-poppin text-center fw-500 fs-30 mt-0 mb-0">Change Your Password</h3>
            <p class="font-poppin text-center fw-400 fs-15 mt-2 mb-4">For security reasons, you must change your password before continuing</p>
            <div class="flex flex-column justify-content-start flex-wrap mt-6 input-div">
                <acv-password-input
                    [form]="forcedPasswordChangeForm"
                    ControlName="password"
                    [ControlLabelText]="'New Password'"
                    [PlaceHolderText]="'Enter New Password'"
                    [overlay]="true"
                    [ShowWordCount]="false"
                    (iconClick)="hide = !hide"
                    [IconClass]="hide ? 'pi-eye-slash' : 'pi-eye'"
                    [IconPosition]="'right'"
                    [IsSubmited]="(!forcedPasswordChangeForm.controls['password'].valid && !resp?.error && forcedPasswordChangeForm.controls['password'].value) || (resp && passMatch && forcedPasswordChangeForm.controls['password'].value) || emptyFieldPass"
                  >
                  </acv-password-input>
                <div class="relative mt-4">
                    <acv-password-input [form]="forcedPasswordChangeForm" ControlName="confirm_password"
                        [ControlLabelText]="'Confirm Password'" [PlaceHolderText]="'Enter Confirm Password'"
                        [IsSubmited]="(resp && resp?.error.message == 'The password field confirmation does not match.' && forcedPasswordChangeForm.controls['confirm_password'].value) || emptyFieldConfirm"
                        [Required]="false" [ShowWordCount]="false" (iconClick)="hideConfirm = !hideConfirm"
                        [IconClass]="hideConfirm ? 'pi-eye-slash' : 'pi-eye'" [IconPosition]="'right'">
                    </acv-password-input>
                    <p class="absolute control_errorMsg font-poppin fw-400 fs-12 mt-0 text-color-red1"
                        *ngIf="emptyFieldConfirm">
                        Please enter the Confirm Password.
                    </p>
                    <p class="absolute control_errorMsg font-poppin fw-400 fs-12 mt-0 text-color-red1"
                        *ngIf="resp && resp?.error.message == 'The password field confirmation does not match.' && forcedPasswordChangeForm.controls['confirm_password'].value">
                        {{resp?.error.message}}
                    </p>
                </div>
            </div>
            <p-button type="submit" [loading]="IsLoading" (click)="handleSubmit()">
                <div class="button-hover-effect1 absolute"></div>
                <div class="button-hover-effect2 absolute"></div>
                <span class="font-poppin fs-14 fw-600 line-height-2 text-align-center"
                    style="padding-left: 25%; position: absolute">{{ IsLoading ? 'Change Password' : 'Change Password' }}</span>
            </p-button>
        </form>
        <div *ngIf="changeSuccess" class="flex flex-column justify-content-center align-items-center">
            <h3 class="font-poppin text-center fw-500 fs-30 mt-0 mb-0 line-height-3 text-color-black">Password Changed</h3>
            <p class="font-poppin text-center fw-400 fs-15 mt-0 mb-0 line-height-2 text-color-grey4">Your password has been changed successfully.
                Redirecting to login...</p>
        </div>
    </div>
    <div class="w-11 flex flex-row justify-content-center">
      <p class="fw-500 fs-14 font-poppin text-color-grey3 line-height-21 text-left mb-0 pt-8 pb-2">&copy; 2024. ACV Logistics</p>
    </div>
  </div>
  <!-- right side page -->
  <div class="w-6 pt-1 pr-3 image-div" style="height: 99vh;">
    <img class="w-full h-full" src="assets/images/Mask group.svg" />
  </div>
</div>

